import { CSSObject } from '@chakra-ui/react';

export const TextItem: CSSObject = {
  textTransform: 'capitalize',
  color: 'alpha.900',
  fontSize: 'xs',
  fontWeight: 'semibold',
};
